import { isGroupOption } from "PFApp/booking/components/booking_form/workforce_member_select/workforce_member_select.utils";
import { EngagementOption } from "PFApp/components/engagement_item";
import { ActivityOption, Id } from "PFTypes";

import { BookingFormValues } from "../booking_form_values.types";

export const parseEngagementToOption = (activity: ActivityOption): EngagementOption => ({
  id: Number(activity.id),
  name: activity.name,
  description: activity.description
});

type GetOwnershipFiltersParams = {
  workforceMember: BookingFormValues["workforceMember"];
  currentProfileId: Id;
  canManagePublicActivityBookings: boolean;
};

export const getOwnershipFilters = ({
  workforceMember,
  currentProfileId,
  canManagePublicActivityBookings
}: GetOwnershipFiltersParams) => {
  // if users book themselves, they need to be contributor unless public engagements policy is enabled
  // if users book other profiles, they need to be owner unless public engagements policy is enabled
  const isGroupSelected = isGroupOption(workforceMember);
  if (!isGroupSelected && workforceMember?.id === currentProfileId) {
    return { contributorId: canManagePublicActivityBookings ? undefined : currentProfileId };
  }
  return { ownerId: canManagePublicActivityBookings ? undefined : currentProfileId };
};
